import { Link } from 'react-router-dom';
import { Separator } from '@/components/ui/separator';
import { Instagram, Video } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[hsl(var(--bk-bg))] border-t border-[hsl(var(--bk-line))]">
      <div className="max-w-[1200px] mx-auto px-5 sm:px-8 py-14 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block">
              <img 
                src="/assets/baklight-logo-white.png" 
                alt="Baklight" 
                className="h-6 w-auto"
              />
            </Link>
            <p className="font-body text-sm text-[hsl(var(--bk-fg-subtle))] mt-4 leading-relaxed max-w-[280px]">
              An integrated production ecosystem for cinematic storytelling.
            </p>
          </div>

          {/* Ecosystem */}
          <div>
            <p className="font-mono-meta text-[hsl(var(--bk-fg-subtle))] mb-4">Ecosystem</p>
            <div className="flex flex-col gap-3">
              <Link to="/services" className="font-body text-sm text-[hsl(var(--bk-fg-muted))] hover:text-[hsl(var(--bk-fg))] transition-colors">Production Services</Link>
              <Link to="/mexico" className="font-body text-sm text-[hsl(var(--bk-fg-muted))] hover:text-[hsl(var(--bk-fg))] transition-colors">Shoot in Mexico</Link>
              <Link to="/post" className="font-body text-sm text-[hsl(var(--bk-fg-muted))] hover:text-[hsl(var(--bk-fg))] transition-colors">Post & Finishing</Link>
              <Link to="/rentals" className="font-body text-sm text-[hsl(var(--bk-fg-muted))] hover:text-[hsl(var(--bk-fg))] transition-colors">Equipment & Rentals</Link>
              <Link to="/innovation" className="font-body text-sm text-[hsl(var(--bk-fg-muted))] hover:text-[hsl(var(--bk-fg))] transition-colors">Innovation / AI</Link>
            </div>
          </div>

          {/* Company */}
          <div>
            <p className="font-mono-meta text-[hsl(var(--bk-fg-subtle))] mb-4">Company</p>
            <div className="flex flex-col gap-3">
              <Link to="/work" className="font-body text-sm text-[hsl(var(--bk-fg-muted))] hover:text-[hsl(var(--bk-fg))] transition-colors">Selected Work</Link>
              <Link to="/director" className="font-body text-sm text-[hsl(var(--bk-fg-muted))] hover:text-[hsl(var(--bk-fg))] transition-colors">Director</Link>
              <Link to="/clients" className="font-body text-sm text-[hsl(var(--bk-fg-muted))] hover:text-[hsl(var(--bk-fg))] transition-colors">Clients & Trust</Link>
              <Link to="/contact" className="font-body text-sm text-[hsl(var(--bk-fg-muted))] hover:text-[hsl(var(--bk-fg))] transition-colors">Contact</Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <p className="font-mono-meta text-[hsl(var(--bk-fg-subtle))] mb-4">Get in Touch</p>
            <div className="flex flex-col gap-3">
              <a href="mailto:info@baklight.com" className="font-body text-sm text-[hsl(var(--bk-accent))] hover:opacity-80 transition-opacity">info@baklight.com</a>
              <a href="mailto:paco@baklight.com" className="font-body text-sm text-[hsl(var(--bk-accent))] hover:opacity-80 transition-opacity">paco@baklight.com</a>
              <p className="font-body text-sm text-[hsl(var(--bk-fg-muted))]">Guadalajara, Mexico</p>
              <p className="font-body text-sm text-[hsl(var(--bk-fg-subtle))]">+52 33 3808 3824</p>
              <a href="https://www.instagram.com/baklight" target="_blank" rel="noopener noreferrer" className="font-body text-sm text-[hsl(var(--bk-fg-muted))] hover:text-[hsl(var(--bk-fg))] transition-colors">@baklight</a>
              
              {/* Social Media Icons */}
              <div className="flex items-center gap-3 mt-2">
                <a 
                  href="https://vimeo.com/baklight" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-[hsl(var(--bk-line))] text-[hsl(var(--bk-fg-muted))] hover:text-[hsl(var(--bk-fg))] hover:border-[hsl(var(--bk-fg-subtle))] transition-colors"
                  aria-label="Vimeo"
                >
                  <Video size={16} />
                </a>
                <a 
                  href="https://www.instagram.com/baklight" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-[hsl(var(--bk-line))] text-[hsl(var(--bk-fg-muted))] hover:text-[hsl(var(--bk-fg))] hover:border-[hsl(var(--bk-fg-subtle))] transition-colors"
                  aria-label="Instagram"
                >
                  <Instagram size={16} />
                </a>
              </div>
            </div>
          </div>
        </div>

        <Separator className="my-10 bg-[hsl(var(--bk-line))]" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-mono-meta text-[hsl(var(--bk-fg-subtle))]">
            &copy; {new Date().getFullYear()} Baklight. All rights reserved.
          </p>
          <p className="font-mono-meta text-[hsl(var(--bk-fg-subtle))] uppercase tracking-wider">
            Based in Mexico. Producing Worldwide.
          </p>
        </div>
      </div>
    </footer>
  );
};
